import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobile', 'text']
  static values = {
    sending: Boolean,
    state: {
      type: Number,
      default: 1000
    },
    id: String
  }
  initialize() {
    this.handlerEvent = this.handler.bind(this)
    this.timer = null
    this.times = 60
  }

  loadGeetest(handler) {
    window.initGeetest4({
      captchaId: '93bc482a3f5423c0fb0482a82a0f7ad7',
        product: 'bind',
    }, handler);
  }

  handler(captchaObj) {
    const self = this
    captchaObj.appendTo("#captcha");
    captchaObj.showCaptcha();

      captchaObj.onReady(function () {
      console.log('ready')
    }).onSuccess(async function () {
      var result = captchaObj.getValidate()
      const res = await fetch('/api/v1/codes', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ geetest: result, mobile: self.mobile, state: self.stateValue, id: self.idValue })
      })
      const json = await res.json()
      console.log(json)
      if (json.status === 'error') {
        alert(json.message)
        captchaObj.reset()
      } else {
        captchaObj.reset()
        self.sendingValue = true
        self.timer = setInterval(() => {
          self.displayText()
        }, 1000)
      }
    })
  }

  open() {
    if (this.sendingValue) {
      return false
    }

    if (![1000, 1001].includes(this.stateValue)) {
      alert('请求出错')
      return
    }


    if (this.mobile === '') {
      alert('请输入手机号')
      return
    }

    if (/^1[3-9]\d{9}$/.test(this.mobile) === false) {
      alert("手机号码格式不正确")
      return
    }

    this.loadGeetest(this.handlerEvent)
  }

  displayText() {
    this.times -= 1
    let text = `${this.times}秒后重发`

    if (this.times == 0) {
      text = '获取短信验证码'
      clearInterval(this.timer)
      this.timer = null
      this.times = 60
      this.sendingValue = false
    }
    this.textTarget.innerHTML = text
  }

  get mobile() {
    return this.mobileTarget.value
  }

  disconnect() {
    clearInterval(this.timer)
    this.timer = null
  }
}
